/* @flow */
import {SET_VIEW_OPTIONS,} from './action-types.js';

/* Toggle enclave selection menu open and closed */
export const setViewOptions = (options: Object) => ({
  type: SET_VIEW_OPTIONS,
  payload: options
});



// WEBPACK FOOTER //
// ./src/app/modules/insights/actions.js